import { AppSettings } from 'src/settings/appsettings.interface';

export function validateAppSettings(config: AppSettings): void {
  const missing: string[] = [];

  // AppSettings
  if (!config.environment) missing.push('environment');
  if (!config.subscriptionServiceBaseUrl) missing.push('subscriptionServiceBaseUrl');
  if (!config.siteBaseUrl) missing.push('siteBaseUrl');
  if (!config.csManagementPortalUrl) missing.push('csManagementPortalUrl');
  if (!config.undoSubscriptionSurveryLink) missing.push('undoSubscriptionSurveryLink');
  if (!config.cancelSubscriptionSurveryLink) missing.push('cancelSubscriptionSurveryLink');
  if (!config.googleMapsMapId) missing.push('googleMapsMapId');
  if (!config.googleMapsApiKey) missing.push('googleMapsApiKey');
  if (typeof config.serviceOrderOrdinaryPriceInDkkInclVat !== 'number') missing.push('serviceOrderOrdinaryPriceInDkkInclVat');
  if (typeof config.serviceOrderUrgentPriceInDkkInclVat !== 'number') missing.push('serviceOrderUrgentPriceInDkkInclVat');
  if (typeof config.serviceOrderRelocationBelow6MetersPriceInDkkInclVat !== 'number')
    missing.push('serviceOrderRelocationBelow6MetersPriceInDkkInclVat');
  if (typeof config.serviceOrderRelocationAbove6MetersPriceInDkkInclVat !== 'number')
    missing.push('serviceOrderRelocationAbove6MetersPriceInDkkInclVat');

  // AuthConfig
  if (!config.authConfig?.issuer) missing.push('authConfig.issuer');
  if (!config.authConfig?.clientId) missing.push('authConfig.clientId');
  if (!config.authConfig?.audience) missing.push('authConfig.audience');

  // FirebaseConfig
  if (!config.firebaseConfig?.apiKey) missing.push('firebaseConfig.apiKey');
  if (!config.firebaseConfig?.projectId) missing.push('firebaseConfig.projectId');
  if (!config.firebaseConfig?.appId) missing.push('firebaseConfig.appId');

  if (missing.length > 0) {
    console.error(`appsettings.json mangler påkrævede felter: ${missing.join(', ')}`);
    throw new Error('appsettings.json mangler en eller flere påkrævede felter.');
  }
}
